import { useState } from "react";

export default function MediaUploader({ value = [], onChange }) {
  const [url, setUrl] = useState("");
  const [type, setType] = useState("image");
  const add = () => {
    if (!url) return;
    const next = [...value, { url, media_type: type }];
    onChange(next);
    setUrl("");
  };
  const remove = (i) => {
    const next = value.filter((_, idx) => idx !== i);
    onChange(next);
  };
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input
          className="flex-1 border p-2 rounded"
          placeholder="https://..."
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <select
          className="border p-2 rounded"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="image">Image</option>
          <option value="doc">Doc</option>
        </select>
        <button
          type="button"
          onClick={add}
          className="px-4 py-2 bg-gray-800 text-white rounded"
        >
          Add
        </button>
      </div>
      <ul className="list-disc ml-5">
        {value.map((m, i) => (
          <li key={i} className="flex items-center justify-between">
            <span className="truncate mr-2">
              [{m.media_type}] {m.url}
            </span>
            <button
              type="button"
              onClick={() => remove(i)}
              className="text-red-600"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
